function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero",
  opacity: 0.3
}, React.createElement("path", {
  d: "M.929.051c.512 0 .928.445.928.995s-.416.995-.928.995C.416 2.04 0 1.595 0 1.046 0 .496.416.05.929.05zM.929 3.865c.512 0 .928.445.928.995s-.416.995-.928.995C.416 5.855 0 5.409 0 4.86c0-.55.416-.995.929-.995zM.929 7.679c.512 0 .928.445.928.994 0 .55-.416.995-.928.995-.513 0-.929-.445-.929-.995 0-.549.416-.994.929-.994zM4.893.051c.513 0 .928.445.928.995s-.415.995-.928.995c-.513 0-.929-.446-.929-.995 0-.55.416-.995.929-.995zM4.893 3.865c.513 0 .928.445.928.995s-.415.995-.928.995c-.513 0-.929-.446-.929-.995 0-.55.416-.995.929-.995zM4.893 7.679c.513 0 .928.445.928.994 0 .55-.415.995-.928.995-.513 0-.929-.445-.929-.995 0-.549.416-.994.929-.994z"
}));

const SvgMoveDouble = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    ref: svgRef
  }, props), _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgMoveDouble, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/move-double.46ce3494.svg";
export { ForwardRef as ReactComponent };